const {setUrl} = require("../utils/video-url");

module.exports = function () {
    const popup = document.querySelector(".popup-video");
    const openButtons = document.querySelectorAll("[data-video]");

    if (!popup || !openButtons.length) return;
    const iframe = popup.querySelector("iframe");
    const inner = popup.querySelector(".popup-video__inner");
    const popupClasses = ["opacity-0", "invisible"];
    

    function openPopup(url) {
        iframe.src = setUrl(url);
        popup.classList.remove(...popupClasses);
        document.body.classList.add("overflow-hidden");

        setTimeout(() => {
            document.addEventListener("click", handleClickOutside);
        })
    }

    function closePopup() {
        iframe.src = "";
        popup.classList.add(...popupClasses);
        document.body.classList.remove("overflow-hidden");
        document.removeEventListener("click", handleClickOutside);
    }

    function handleClickOutside(e) {
        if ( !inner?.contains(e.target) ) closePopup();
    }

    for (const button of openButtons) {
        button.addEventListener("click", (e) => {
            e.preventDefault();
            openPopup( button.dataset.video );
        });
    }
}